// Vorys Quiz — 3 soru, sonra direkt PDP redirect

// Newsletter/email popup suppressor — quiz sayfasında UX'i kesmesin
(function suppressPopups() {
  function isQuizPopup(el) {
    if (!el || el.id === 'vorys-quiz' || el.closest('#vorys-quiz')) return false;
    const pos = getComputedStyle(el).position;
    if (pos !== 'fixed' && pos !== 'absolute') return false;
    const txt = (el.textContent || '').toLowerCase();
    return (
      txt.includes('mükemmel fırsat') ||
      txt.includes('sepette10') ||
      txt.includes('kayıt ol,kodu al') ||
      txt.includes('kayıt ol, kodu al') ||
      txt.includes('indirimi kaçırmak istiyorum')
    );
  }
  function purge() {
    document.querySelectorAll('body > *, body > * > *').forEach(el => {
      if (isQuizPopup(el)) {
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      }
    });
    // Body scroll lock'ı kaldır
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  }
  purge();
  if ('MutationObserver' in window) {
    new MutationObserver(purge).observe(document.body, { childList: true, subtree: true });
  }
  // Geç yüklenen popupları yakalamak için 1.5s ve 4s'de bir daha çalıştır
  setTimeout(purge, 1500);
  setTimeout(purge, 4000);
})();

(function() {
  'use strict';
  if (!window.VorysQuiz) return;

  const answers = { kim: null, kullanim: null, renk: null };
  const STEPS = ['intro', 'q1', 'q2', 'q3'];
  let currentStep = 0;
  let busy = false;

  const root = document.getElementById('vorys-quiz');
  if (!root) return;

  const progressEl   = document.getElementById('quiz-progress');
  const progressFill = document.getElementById('quiz-progress-fill');
  const progressNum  = document.getElementById('quiz-progress-count');
  const backBtn      = document.getElementById('quiz-back');

  function pad2(n) { return n < 10 ? '0' + n : String(n); }

  function showStep(idx) {
    currentStep = idx;
    const step = STEPS[idx];

    root.querySelectorAll('.vq-step').forEach(s => {
      s.classList.toggle('active', s.dataset.step === step);
    });

    if (step === 'intro') {
      progressEl.style.display = 'none';
    } else {
      progressEl.style.display = 'flex';
      const qIdx = STEPS.indexOf(step); // 1, 2, 3
      progressFill.style.width = (qIdx / 3 * 100) + '%';
      progressNum.textContent = pad2(qIdx) + ' / 03';
      backBtn.style.display = qIdx === 1 ? 'none' : 'inline-flex';
    }

    history.replaceState(null, '', '#step=' + step);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  // BAŞLA
  root.addEventListener('click', function(e) {
    const startBtn = e.target.closest('[data-action="start"]');
    if (startBtn && !busy) {
      if (typeof clarity === 'function') clarity('event', 'quiz_started');
      showStep(STEPS.indexOf('q1'));
    }
  });

  // Geri
  backBtn.addEventListener('click', function() {
    if (busy) return;
    if (currentStep > 1) showStep(currentStep - 1);
  });

  // Q option click
  root.addEventListener('click', function(e) {
    if (busy) return;
    const opt = e.target.closest('.vq-opt');
    if (!opt) return;

    const stepEl = opt.closest('.vq-step');
    if (!stepEl) return;
    const q = stepEl.dataset.q;
    if (!q) return;

    stepEl.querySelectorAll('.vq-opt').forEach(s => s.classList.remove('sel'));
    opt.classList.add('sel');
    answers[q] = opt.dataset.val;

    if (typeof clarity === 'function') {
      clarity('event', 'quiz_' + q + '_answered');
      clarity('set', 'quiz_' + q, opt.dataset.val);
    }

    setTimeout(function() {
      if (currentStep < STEPS.indexOf('q3')) {
        showStep(currentStep + 1);
      } else {
        completeQuiz();
      }
    }, 320);
  });

  async function findVariantId(handle, targetColor, targetCam) {
    try {
      const r = await fetch('/products/' + handle + '.js');
      if (!r.ok) return null;
      const product = await r.json();
      if (!product || !product.variants) return null;

      const camKeyword = targetCam === 'Polarize Füme' ? 'Polarize' : 'Dinlendirici';

      // 1) Exact match: renk + cam
      let v = product.variants.find(function(v) {
        const opts = (v.options || []).map(function(o){ return (o||'').toString().trim(); });
        const colorHit = opts.some(function(o){ return o === targetColor; });
        const camHit = opts.some(function(o){ return o.indexOf(camKeyword) !== -1; });
        return colorHit && camHit;
      });
      if (v) return v.id;

      // 2) Contains fallback: renk substring + cam
      v = product.variants.find(function(v) {
        const opts = (v.options || []).map(function(o){ return (o||'').toString(); });
        const colorHit = opts.some(function(o){ return o.indexOf(targetColor) !== -1 || targetColor.indexOf(o) !== -1; });
        const camHit = opts.some(function(o){ return o.indexOf(camKeyword) !== -1; });
        return colorHit && camHit;
      });
      if (v) return v.id;

      // 3) Sadece cam match (renk fallback)
      v = product.variants.find(function(v) {
        const opts = (v.options || []);
        return opts.some(function(o){ return (o||'').indexOf(camKeyword) !== -1; });
      });
      if (v) return v.id;

      // 4) Default first
      return product.variants[0] ? product.variants[0].id : null;
    } catch (e) {
      console.warn('Variant lookup failed:', e);
      return null;
    }
  }

  async function completeQuiz() {
    busy = true;
    const rec = VorysQuiz.recommend(answers);

    if (typeof clarity === 'function') {
      clarity('event', 'quiz_completed');
      clarity('set', 'quiz_path', rec.quizPath);
      clarity('set', 'quiz_match', rec.handle);
    }
    if (typeof fbq === 'function') {
      fbq('track', 'Lead', {
        content_category: 'quiz',
        content_name: rec.name,
        content_ids: [rec.handle],
      });
    }

    localStorage.setItem('vorys_quiz_answers', JSON.stringify(answers));
    localStorage.setItem('vorys_quiz_match', JSON.stringify({
      handle: rec.handle, color: rec.color, cam: rec.cam, at: Date.now()
    }));

    // Reveal'ı paralel başlat — variant lookup arka planda
    const reveal = document.createElement('div');
    reveal.className = 'vq-reveal';
    reveal.innerHTML =
      '<div class="vq-reveal-inner">' +
        '<p class="vq-reveal-eyebrow">SANA UYGUN</p>' +
        '<h2 class="vq-reveal-name">' + rec.name + '</h2>' +
        '<p class="vq-reveal-sub">' + rec.color + ' &middot; ' + rec.cam + '</p>' +
        '<div class="vq-reveal-loader"><span></span></div>' +
      '</div>';
    document.body.appendChild(reveal);
    requestAnimationFrame(function() {
      reveal.classList.add('visible');
    });

    // Variant lookup paralel
    const variantId = await findVariantId(rec.handle, rec.color, rec.cam);

    const params = new URLSearchParams(rec.queryParams);
    if (variantId) {
      params.set('variant', variantId);
    }
    const url = '/products/' + rec.handle + '?' + params.toString();

    // Reveal süresinin tamamını bekle (toplam ~1.4s)
    setTimeout(function() {
      window.location.href = url;
    }, 1100);
  }

  showStep(0);
})();
